import React, { Suspense, lazy } from 'react';
import { ReactComponent as Logo } from 'assets/archre-logo-blue.svg';
import {
  Navigation,
  NavItem,
  LayoutHeader,
  NavigationDropDown,
  useArchReAppContext,
  useAuthContext,
} from '@archre2/react-core';
// Import constants directly to avoid pulling in entire modules
import { name as adminName } from './administration/config/constants';
import { name as billingName } from './billing/config/constants';
import SubNavigation from '../modules/administration/config/navigation';
import SubNavigationBilling from '../modules/billing/config/navigation';
import SubNavigationTools from '../modules/tools/config/navigation';
import { Can } from '../auth';
import { userPermissions } from 'constants/userPermissions';
import config from 'config';
import { NavLink } from 'react-router-dom';

const UserInfo = lazy(() => import('./user/userInfo'));

export default function MainNavigation() {
  const { session } = useAuthContext();
  const isArchUser = session.connectionType === 'Arch';
  const locationUrl = config.LOCATION.locationUrl;

  const isAdmin =
    session.userPermissions &&
    session.userPermissions.includes(userPermissions.READ_ALL);
  const canViewWorkflow = config.WORKFLOW.isIRFeatureOn;
  const { navigate } = useArchReAppContext();
  return (
    <LayoutHeader>
      <Logo onClick={() => navigate('/')} className="logo" />
      <Navigation className="nav nav--horizontal flex-grow">
        <Can
          perform={userPermissions.MANAGE_SPA}
          yes={() => (
            <NavigationDropDown title={adminName} path={`/${adminName}`}>
              <SubNavigation isAdmin={isAdmin} />
            </NavigationDropDown>
          )}
        />
        {canViewWorkflow && (
          <Can
            perform={userPermissions.MANAGE_SPA}
            yes={() => (
              <NavItem className="item" path="/Workflow" name="Workflow" />
            )}
          />
        )}
        <Can
          perform={userPermissions.LIST_PROGRAM}
          yes={() => (
            <NavItem className="item" path="/Programs" name="Programs" />
          )}
        />
        <Can
          perform={userPermissions.LIST_POLICY}
          yes={() => (
            <NavItem className="item" path="/Policies" name="Policies" />
          )}
        />
        <Can
          perform={userPermissions.MANAGE_BDX}
          yes={() => <NavItem className="item" path="/BDX" name="BDX" />}
        />
        <Can
          perform={userPermissions.READ_REPORT}
          yes={() => (
            <NavItem
              className="item"
              path="/Reports"
              name="Reports"
              tab="All"
            />
          )}
        />
        <Can
          perform={userPermissions.LIST_PROGRAM}
          yes={() => (
            <NavigationDropDown title={billingName} path={`/${billingName}`}>
              <SubNavigationBilling />
            </NavigationDropDown>
          )}
        />
        {(isAdmin || isArchUser) && (
          <Can
            perform={userPermissions.LIST_TOOLS}
            yes={() => (
              <NavigationDropDown title={'Tools'} path={`/${'Tools'}`}>
                <SubNavigationTools isAdmin={isAdmin} isArchUser={isArchUser} />
              </NavigationDropDown>
            )}
          />
        )}
        {(isAdmin || isArchUser) && (
          <li className="item">
            <NavLink
              to={locationUrl}
              tabIndex={0}
              target="_blank"
              rel="noopener noreferrer"
            >
              Location
            </NavLink>
          </li>
        )}
      </Navigation>
      <Suspense fallback={null}>
        <UserInfo />
      </Suspense>
    </LayoutHeader>
  );
}
